import Vue from "vue";
import VueI18n from "vue-i18n";

Vue.use(VueI18n);
const messages = {
    en: {
        gems: "gems",
        solveProblems: "Now talk, solve your problems",
        Makefriends: "Make friends",
        talkAboutRomantic: "Make new friends and tell your heart",
        Astrology: "Astrology",
        problems: "Remove the problems of yourself and your home",
        Baatein91: "Baatein91",
        Callhistory: "Call history",
        Nosufficientbal: "You don't have sufficient balance",
        Findfriends: "Find friends",
        Calling: "Calling…",
        Connecting: "Connecting...",
        Mute: "Mute",
        Speaker: "Speaker",
        Lookingfriends: "Looking new friends for you…",
        callWaiting: "Your call waiting is going on.",
        wanttotalk: "Do you want to talk to someone else?",
        clickButton: "Then click on the button below. Otherwise wait, you are in the queue and your queue number is {userPositiontxt}.",
        FindAnotherFriend: "Find another friend",
        walletbal: "You have <b> {userbal} Gems</b> in your wallet।",
        Muteoff: "Mute off",
        Muteon: "Mute on",
        TermsandConditions: "Terms and Conditions",
        callRate: "1. The minimum call talk rate is <b> 10 gems / min </b>",
        callTime: "2. You can only talk for up to <b> 4 minutes </b> on a call at a time.",
        minAmount: "3. Your wallet must have a minimum of <b> 10 gems </b>",
        Caution: "Caution",
        nodirtyTalk: "If you make indecent or any dirty talk during the call, your account will be closed immediately.",
        wallet: "Wallet",
        job: "1. Do not look for your job?",
        married: "2. Are you not getting married?",
        children: "3. Are you not having children?",
        marriedLife: "4. Has there been a breakdown in your marriage?",
        talkAstrology: "Or are you facing some other problem besides these. So talk to us astrology and remove your problems.",
        comingsoon: "We are coming soon to overcome your problems with our astrology.",
        terms: "I have read all the <b> Terms and Conditions </b> and I agree with it. "


    },
    hi: {
        gems: "जेम्स",
        solveProblems: "अब बातो ही बातो में जाने अपनी समस्याओ का हल",
        Makefriends: "दोस्त बनाये",
        talkAboutRomantic: "नए दोस्त बनाएं और बताए अपने दिल का हाल",
        Astrology: "ज्योतिष",
        problems: "दूर करे अपनी और अपने घर की दिक्कतों को",
        Baatein91: "बातें91",
        Callhistory: "कॉल की हिस्ट्री",
        Nosufficientbal: "आपके पास पर्याप्त बैलेंस नहीं है।",
        Findfriends: "दोस्त ढूंढे ",
        Calling: "कॉल लग रहा है…",
        Connecting: "कनेक्ट हो रहा है",
        Mute: "म्यूट करें",
        Speaker: "स्पीकर ",
        Lookingfriends: "आपके लिए नए दोस्त खोज रहे है…",
        callWaiting: "आपका कॉल वेटिंग जा रही है।",
        wanttotalk: " क्या आप किसी और से बात करना चाहते है?",
        clickButton: "तो नीचे दिए हुए बटन पे क्लिक करे। अन्यथा इंतज़ार करे, आप कतार में है और आपकी कतार सख्या {userPositiontxt} है।",
        FindAnotherFriend: "दूसरा दोस्त ढूढे",
        walletbal: "आपके वॉलेट में <b>{userbal} जेम्स</b> हैं।",
        Muteoff: "म्यूट बंद करें",
        Muteon: "म्यूट करें",
        TermsandConditions: "नियम और शर्ते",
        callRate: "1. कॉल पे बात करने का न्यूनतम रेट <b> 10 जेम्स /मिनट</b> है",
        callTime: "2. आप एक बार में कॉल पर <b>4 मिनट</b> तक ही बात कर सकते है ",
        minAmount: "3. आपके वॉलेट में न्यूनतम <b>10 जेम्स </b> होना चाहिए",
        Caution: "सावधानी",
        nodirtyTalk: "अगर आप कॉल के दुअरान अश्लील या कोई भी गन्दी बात करते है तो आपका अकाउंट तुरंत बंद कर दिया जाएगा।",
        wallet: "वॉलेट",
        job: "1. क्या आपकी नौकरी नहीं लग रही है ?",
        married: "2. क्या आपकी शादी नहीं हो पा रही है?",
        children: "3. क्या आपकी संतान नहीं हो रही है ?",
        marriedLife: "4. क्या आपकी वैवाहिक जीवन में रिश्ता टूटने की नौबत आ गई है ?",
        talkAstrology: "या इनके अलावा कुछ और दिक्कत का सामना आप कर रहे है। तो बात कीजिये हमारे ज्योतिष से और अपनी दिक्कतों को दूर करे।",
        comingsoon: "हम जल्द आ रहे है अपने ज्योतिष के साथ आपकी दिक्कतों को दूर करने",
        terms: " मैने सारी <b> नियम और शर्ते </b> पढ़ ली है,और मैं इससे सहमत हू।"

    },
    bn: {
        gems: "জেমস",
        solveProblems: "এখন কথা বলুন, আপনার সমস্যাগুলি সমাধান করুন",
        Makefriends: "বন্ধু বানানো",
        talkAboutRomantic: "নতুন বন্ধু তৈরি করুন এবং আপনার হৃদয়ের অবস্থা জানুন",
        Astrology: "জ্যোতিষ",
        problems: "আপনার সমস্যা এবং আপনার বাড়িতে দূরে",
        Baatein91: "Baatein91",
        Callhistory: "কলের ইতিহাস",
        Nosufficientbal: "আপনার পর্যাপ্ত ভারসাম্য নেই",
        Findfriends: "বন্ধুদের অনুসন্ধান",
        Calling: "কল করা হচ্ছে ...",
        Connecting: "সংযুক্ত হচ্ছে ...",
        Mute: "মূক",
        Speaker: "বক্তা",
        Lookingfriends: "আপনার জন্য নতুন বন্ধু খুঁজছেন ...",
        callWaiting: "আপনার কল ওয়েটিং চলছে।",
        wanttotalk: "আপনি অন্য কারও সাথে কথা বলতে চান?",
        clickButton: "তারপরে নীচের বোতামে ক্লিক করুন। অন্যথায় অপেক্ষা করুন, আপনি কাতারে রয়েছেন এবং আপনার সারির নম্বরটি {userPositiontxt}",
        FindAnotherFriend: "আর এক বন্ধুকে সন্ধান করুন",
        walletbal: "আপনার মানিব্যাগে <b>{userbal} জেমস</b>",
        Muteoff: "নিঃশব্দ করা",
        Muteon: "নিঃশব্দ করা",
        TermsandConditions: "শর্তাবলী",
        callRate: "1. সর্বনিম্ন কল টক রেট <b> 10 জেমস / মিনিট </ b>",
        callTime: "২. আপনি একবারে কল করতে <b> 4 মিনিট </ b> অবধি কথা বলতে পারেন।",
        minAmount: "৩. আপনার মানিব্যাগটিতে সর্বনিম্ন <b>10 জেমস </ b> থাকতে হবে",
        Caution: "সতর্ক করা",
        nodirtyTalk: "যদি আপনি কল চলাকালীন অশালীন বা কোনও নোংরা কথা বলেন তবে আপনার অ্যাকাউন্টটি অবিলম্বে বন্ধ হয়ে যাবে।",
        wallet: "মানিব্যাগ",
        job: "1. আপনার কাজ খুঁজছেন না?",
        married: "২) আপনি কি বিয়ে করছেন না?",
        children: "৩. আপনার বাচ্চা হচ্ছে না?",
        marriedLife: "৪. আপনার বিবাহবন্ধনে কোনও বিচ্ছেদ হয়েছে?",
        talkAstrology: "অথবা আপনি এগুলি ছাড়াও অন্য কোনও সমস্যার মুখোমুখি হচ্ছেন। সুতরাং আমাদের সাথে জ্যোতিষের সাথে কথা বলুন এবং আপনার সমস্যাগুলি সরিয়ে দিন।",
        comingsoon: "আমরা আমাদের জ্যোতিষ নিয়ে আপনার সমস্যাগুলি কাটিয়ে উঠতে শীঘ্রই আসছি।",
        terms: "আমি সমস্ত <b> শর্তাবলী </ b> পড়েছি এবং আমি এটিতে সম্মত। "


    },
    gu: {
        gems: "જેમ્સ",
        solveProblems: "હવે વાત કરો, તમારી સમસ્યાઓ હલ કરો",
        Makefriends: "મિત્રો બનાવો",
        talkAboutRomantic: "નવા મિત્રો બનાવો અને તમારા હૃદયની સ્થિતિ જાણો",
        Astrology: "જ્યોતિષવિદ્યા",
        problems: "તમારી સમસ્યાઓ અને તમારા ઘરથી દૂર",
        Baatein91: "બાટેન 91",
        Callhistory: "કૉલ ઇતિહાસ",
        Nosufficientbal: "તમારી પાસે પૂરતું બેલેન્સ નથી",
        Findfriends: "મિત્રો શોધો",
        Calling: "કingલ કરી રહ્યાં છે ...",
        Connecting: "કનેક્ટ થઈ રહ્યું છે ...",
        Mute: "મૌન",
        Speaker: "સ્પીકર",
        Lookingfriends: "તમારા માટે નવા મિત્રો જોઈએ છે ...",
        callWaiting: "તમારી ક callલ પ્રતીક્ષા ચાલુ છે.",
        wanttotalk: "શું તમે કોઈ બીજા સાથે વાત કરવા માંગો છો?",
        clickButton: "પછી નીચે બટન પર ક્લિક કરો. અન્યથા પ્રતીક્ષા કરો, તમે કતારમાં છો અને તમારો કતાર નંબર {userPositiontxt} છે.",
        FindAnotherFriend: "બીજો મિત્ર શોધો",
        walletbal: "તમારી પાસે તમારા વletલેટમાં <b> {userbal} જેમ્સ </ b>.",
        Muteoff: "મ્યૂટ ઓફ",
        Muteon: "મ્યૂટ કરો",
        TermsandConditions: "નિયમો અને શરત",
        callRate: "1. ન્યૂનતમ ક callલ ટ talkક રેટ <b> 10 જેમ્સ / મિનિટ </ b> છે",
        callTime: "2. તમે એક સમયે ક callલ પર ફક્ત <b> 4 મિનિટ </ b> સુધી વાત કરી શકો છો.",
        minAmount: "તમારા વletલેટમાં ઓછામાં ઓછું <b> 10 જેમ્સ </ b> હોવું આવશ્યક છે",
        Caution: "સાવધાની",
        nodirtyTalk: "જો તમે ક callલ દરમિયાન અભદ્ર અથવા કોઈપણ ગંદા વાતો કરો છો, તો તમારું એકાઉન્ટ તરત જ બંધ થઈ જશે.",
        wallet: "વૉલેટ",
        job: "1. તમારી નોકરી શોધી નથી?",
        married: "2. શું તમે લગ્ન કરી રહ્યા નથી?",
        children: "શું તમને સંતાન નથી?",
        marriedLife: "શું તમારા લગ્નજીવનમાં કોઈ ભંગાણ પડ્યું છે?",
        talkAstrology: "અથવા તમે આ સિવાય કોઇ બીજી સમસ્યાનો સામનો કરી રહ્યા છો. તો અમારી સાથે જ્યોતિષની વાત કરો અને તમારી સમસ્યાઓ દૂર કરો.",
        comingsoon: "અમે જ્યોતિષ સાથે તમારી સમસ્યાઓ દૂર કરવા માટે જલ્દી આવી રહ્યા છીએ.",
        terms: "મેં તમામ <b> નિયમો અને શરતો </ b> વાંચી છે અને હું તેની સાથે સંમત છું. "



    },
    kn: {
        gems: "ಜೇಮ್ಸ್",
        solveProblems: "ಈಗ ಮಾತನಾಡಿ, ನಿಮ್ಮ ಸಮಸ್ಯೆಗಳನ್ನು ಪರಿಹರಿಸಿ",
        Makefriends: "ಗೆಳೆಯರನ್ನು ಮಾಡಿಕೊಳ್ಳಿ",
        talkAboutRomantic: "ಹೊಸ ಸ್ನೇಹಿತರನ್ನು ಮಾಡಿ ಮತ್ತು ನಿಮ್ಮ ಹೃದಯದ ಸ್ಥಿತಿಯನ್ನು ತಿಳಿದುಕೊಳ್ಳಿ",
        Astrology: "ಜ್ಯೋತಿಷ್ಯ",
        problems: "ನಿಮ್ಮ ಸಮಸ್ಯೆಗಳಿಗೆ ಮತ್ತು ನಿಮ್ಮ ಮನೆಗೆ ದೂರ",
        Baatein91: "ಬಾಟೆನ್ 91",
        Callhistory: "ಕರೆ ಇತಿಹಾಸ",
        Nosufficientbal: "ನಿಮಗೆ ಸಾಕಷ್ಟು ಸಮತೋಲನ ಇಲ್ಲ",
        Findfriends: "ಸ್ನೇಹಿತರನ್ನು ಹುಡುಕು",
        Calling: "ಕರೆ ಮಾಡಲಾಗುತ್ತಿದೆ…",
        Connecting: "ಸಂಪರ್ಕಿಸಲಾಗುತ್ತಿದೆ ...",
        Mute: "ಮ್ಯೂಟ್ ಮಾಡಿ",
        Speaker: "ಸ್ಪೀಕರ್",
        Lookingfriends: "ನಿಮಗಾಗಿ ಹೊಸ ಸ್ನೇಹಿತರನ್ನು ಹುಡುಕುತ್ತಿದ್ದೇವೆ…",
        callWaiting: "ನಿಮ್ಮ ಕರೆ ಕಾಯುವಿಕೆ ನಡೆಯುತ್ತಿದೆ.",
        wanttotalk: "ನೀವು ಬೇರೆಯವರೊಂದಿಗೆ ಮಾತನಾಡಲು ಬಯಸುವಿರಾ?",
        clickButton: "ನಂತರ ಕೆಳಗಿನ ಬಟನ್ ಕ್ಲಿಕ್ ಮಾಡಿ. ಇಲ್ಲದಿದ್ದರೆ ಕಾಯಿರಿ, ನೀವು ಸರದಿಯಲ್ಲಿದ್ದೀರಿ ಮತ್ತು ನಿಮ್ಮ ಕ್ಯೂ ಸಂಖ್ಯೆ {userPositiontxt} ಆಗಿದೆ.",
        FindAnotherFriend: "ಇನ್ನೊಬ್ಬ ಸ್ನೇಹಿತನನ್ನು ಹುಡುಕಿ",
        walletbal: "ನಿಮ್ಮ ಬಳಿ ನಿಮ್ಮ ಕೈಚೀಲದಲ್ಲಿ <b> {userbal} ಜೇಮ್ಸ್ </b>>",
        Muteoff: "ಮ್ಯೂಟ್ ಆಫ್ ಮಾಡಿ",
        Muteon: "ಮ್ಯೂಟ್ ಮಾಡಿ",
        TermsandConditions: "ನಿಯಮಗಳು ಮತ್ತು ಷರತ್ತುಗಳು",
        callRate: "1. ಕನಿಷ್ಠ ಕರೆ ಮಾತುಕತೆ ದರ <b> 10 ಜೇಮ್ಸ್ / ನಿಮಿಷ </ b>",
        callTime: "2. ನೀವು ಒಂದು ಸಮಯದಲ್ಲಿ ಕರೆಯಲ್ಲಿ <b> 4 ನಿಮಿಷಗಳು </ b> ವರೆಗೆ ಮಾತ್ರ ಮಾತನಾಡಬಹುದು.",
        minAmount: "3. ನಿಮ್ಮ ವ್ಯಾಲೆಟ್ ಕನಿಷ್ಠ <b> 10 ಜೇಮ್ಸ್ </b> ಅನ್ನು ಹೊಂದಿರಬೇಕು",
        Caution: "ಎಚ್ಚರಿಕೆ",
        nodirtyTalk: "ಕರೆ ಸಮಯದಲ್ಲಿ ನೀವು ಅಸಭ್ಯ ಅಥವಾ ಯಾವುದೇ ಕೊಳಕು ಮಾತುಗಳನ್ನು ಮಾಡಿದರೆ, ನಿಮ್ಮ ಖಾತೆಯನ್ನು ತಕ್ಷಣವೇ ಮುಚ್ಚಲಾಗುತ್ತದೆ.",
        wallet: "Wallet",
        job: "1. ನಿಮ್ಮ ಕೆಲಸಕ್ಕಾಗಿ ನೋಡಬೇಡಿ?",
        married: "2. ನೀವು ಮದುವೆಯಾಗುತ್ತಿಲ್ಲವೇ?",
        children: "3. ನೀವು ಮಕ್ಕಳನ್ನು ಹೊಂದಿಲ್ಲವೇ?",
        marriedLife: "4. ನಿಮ್ಮ ದಾಂಪತ್ಯದಲ್ಲಿ ವಿಘಟನೆ ಕಂಡುಬಂದಿದೆಯೇ?",
        talkAstrology: "ಅಥವಾ ಇವುಗಳ ಹೊರತಾಗಿ ನೀವು ಬೇರೆ ಯಾವುದಾದರೂ ಸಮಸ್ಯೆಯನ್ನು ಎದುರಿಸುತ್ತಿದ್ದೀರಾ. ಆದ್ದರಿಂದ ನಮ್ಮೊಂದಿಗೆ ಜ್ಯೋತಿಷ್ಯವನ್ನು ಮಾತನಾಡಿ ಮತ್ತು ನಿಮ್ಮ ಸಮಸ್ಯೆಗಳನ್ನು ತೆಗೆದುಹಾಕಿ.",
        comingsoon: "ನಮ್ಮ ಜ್ಯೋತಿಷ್ಯದೊಂದಿಗಿನ ನಿಮ್ಮ ಸಮಸ್ಯೆಗಳನ್ನು ನಿವಾರಿಸಲು ನಾವು ಶೀಘ್ರದಲ್ಲೇ ಬರುತ್ತಿದ್ದೇವೆ.",
        terms: "ನಾನು ಎಲ್ಲಾ <b> ನಿಯಮಗಳು ಮತ್ತು ಷರತ್ತುಗಳನ್ನು </ b> ಓದಿದ್ದೇನೆ ಮತ್ತು ನಾನು ಅದನ್ನು ಒಪ್ಪುತ್ತೇನೆ. "


    },
    ml: {
        gems: "ജെയിംസ്",
        solveProblems: "ഇപ്പോൾ സംസാരിക്കുക, നിങ്ങളുടെ പ്രശ്നങ്ങൾ പരിഹരിക്കുക",
        Makefriends: "ചങ്ങാതിമാരെ ഉണ്ടാക്കുക",
        talkAboutRomantic: "പുതിയ ചങ്ങാതിമാരെ ഉണ്ടാക്കുക, നിങ്ങളുടെ ഹൃദയസ്ഥിതി അറിയുക",
        Astrology: "ജ്യോതിഷം",
        problems: "നിങ്ങളുടെ പ്രശ്‌നങ്ങൾക്കും വീടിനും അകലെ",
        Baatein91: "ബഅതെഇന്൯൧",
        Callhistory: "കോൾ ചരിത്രം",
        Nosufficientbal: "നിങ്ങൾക്ക് മതിയായ ബാലൻസ് ഇല്ല",
        Findfriends: "സുഹൃത്തുക്കളെ കണ്ടെത്താൻ",
        Calling: "വിളിക്കുന്നു…",
        Connecting: "ബന്ധിപ്പിക്കുന്നു ...",
        Mute: "നിശബ്ദമാക്കുക",
        Speaker: "സ്പീക്കർ",
        Lookingfriends: "നിങ്ങൾക്കായി പുതിയ ചങ്ങാതിമാരെ തിരയുന്നു…",
        callWaiting: "നിങ്ങളുടെ കോൾ കാത്തിരിപ്പ് നടക്കുന്നു.",
        wanttotalk: "നിങ്ങൾക്ക് മറ്റൊരാളോട് സംസാരിക്കാൻ ആഗ്രഹമുണ്ടോ?",
        clickButton: "തുടർന്ന് ചുവടെയുള്ള ബട്ടണിൽ ക്ലിക്കുചെയ്യുക. അല്ലെങ്കിൽ കാത്തിരിക്കുക, നിങ്ങൾ ക്യൂവിലാണ്, നിങ്ങളുടെ ക്യൂ നമ്പർ {userPositiontxt} ആണ്.",
        FindAnotherFriend: "മറ്റൊരു സുഹൃത്തിനെ കണ്ടെത്തുക",
        walletbal: "നിങ്ങൾക്ക് നിങ്ങളുടെ വാലറ്റിൽ <b> {userbal} ജെയിംസ് </b>",
        Muteoff: "നിശബ്ദമാക്കുക",
        Muteon: "നിശബ്ദമാക്കുക",
        TermsandConditions: "ഉപാധികളും നിബന്ധനകളും",
        callRate: "1. ഏറ്റവും കുറഞ്ഞ കോൾ ടോക്ക് നിരക്ക് <b> 10 ജെയിംസ് / മിനിറ്റ് </ b> ആണ്",
        callTime: "2. നിങ്ങൾക്ക് ഒരു സമയം ഒരു കോളിൽ <b> 4 മിനിറ്റ് </ b> വരെ മാത്രമേ സംസാരിക്കാൻ കഴിയൂ.",
        minAmount: "3. നിങ്ങളുടെ വാലറ്റിന് കുറഞ്ഞത് <b> 10 ജെയിംസ് </ b> ഉണ്ടായിരിക്കണം",
        Caution: "ജാഗ്രത",
        nodirtyTalk: "കോൾ സമയത്ത് നിങ്ങൾ മോശമായി സംസാരിക്കുകയോ മോശമായി സംസാരിക്കുകയോ ചെയ്താൽ, നിങ്ങളുടെ അക്കൗണ്ട് ഉടനടി അടയ്ക്കും.",
        wallet: "വാലറ്റ്",
        job: "1. നിങ്ങളുടെ ജോലി അന്വേഷിക്കുന്നില്ലേ?",
        married: "2. നിങ്ങൾ വിവാഹം കഴിക്കുന്നില്ലേ?",
        children: "3. നിങ്ങൾക്ക് കുട്ടികളില്ലേ?",
        marriedLife: "4. നിങ്ങളുടെ ദാമ്പത്യത്തിൽ തകരാർ സംഭവിച്ചിട്ടുണ്ടോ?",
        talkAstrology: "അല്ലെങ്കിൽ ഇവ കൂടാതെ നിങ്ങൾക്ക് മറ്റെന്തെങ്കിലും പ്രശ്‌നമുണ്ടോ? അതിനാൽ ഞങ്ങളോട് ജ്യോതിഷം സംസാരിക്കുകയും നിങ്ങളുടെ പ്രശ്നങ്ങൾ നീക്കം ചെയ്യുകയും ചെയ്യുക.",
        comingsoon: "ഞങ്ങളുടെ ജ്യോതിഷത്തിലെ നിങ്ങളുടെ പ്രശ്നങ്ങൾ മറികടക്കാൻ ഞങ്ങൾ ഉടൻ വരുന്നു.",
        terms: "എല്ലാ <b> നിബന്ധനകളും വ്യവസ്ഥകളും </ b> ഞാൻ വായിച്ചിട്ടുണ്ട്, ഞാൻ ഇതിനോട് യോജിക്കുന്നു. "



    },
    mr: {
        gems: "जेम्स",
        solveProblems: "Nowबोला, आपल्या समस्या सोडवा",
        Makefriends: "मित्र बनवा",
        talkAboutRomantic: "नवीन मित्र बनवा आणि आपल्या हृदयाची स्थिती जाणून घ्या",
        Astrology: "ज्योतिषशास्त्र",
        problems: "आपल्या समस्या आणि आपल्या घरापर्यंत",
        Baatein91: "बाटेइन 91",
        Callhistory: "कॉल इतिहास",
        Nosufficientbal: "आपल्याकडे पुरेसा शिल्लक नाही",
        Findfriends: "मित्र शोधा",
        Calling: "कॉल करीत आहे…",
        Connecting: "कनेक्ट करीत आहे ...",
        Mute: "नि: शब्द करा",
        Speaker: "स्पीकर",
        Lookingfriends: "आपल्यासाठी नवीन मित्र शोधत आहे ...",
        callWaiting: "आपली कॉल प्रतीक्षा चालू आहे.",
        wanttotalk: "तुम्हाला कोणाशी तरी बोलायचं आहे?",
        clickButton: "मग खालील बटणावर क्लिक करा. अन्यथा थांबा, आपण रांगेत आहात आणि आपला रांग क्रमांक {userPositiontxt} आहे.",
        FindAnotherFriend: "दुसरा मित्र शोधा",
        walletbal: "आपल्याकडे  आपल्या वॉलेटमध्ये <b> {userbal} जेम्स </ b>.",
        Muteoff: "नि: शब्द बंद",
        Muteon: "नि: शब्द करा",
        TermsandConditions: "नियम आणि अटी",
        callRate: "1. किमान कॉल टॉक रेट <b> 10 जेम्स / मिनिट </ b> आहे",
        callTime: "२. आपण एकावेळी कॉलवर केवळ <b> 4 मिनिटे </ b> पर्यंत बोलू शकता.",
        minAmount: "Your. आपल्या पाकीटमध्ये कमीतकमी <b> 10 जेम्स </ b> असणे आवश्यक आहे",
        Caution: "सावधगिरी",
        nodirtyTalk: "कॉल दरम्यान आपण अशोभनीय किंवा कोणतीही गलिच्छ चर्चा केल्यास आपले खाते त्वरित बंद होईल.",
        wallet: "पाकीट",
        job: "1. आपली नोकरी शोधू नका?",
        married: "2. तुमचं लग्न होत नाहीये का?",
        children: "3. तुम्हाला मुलं होत नाहीत का?",
        marriedLife: "4. तुमच्या वैवाहिक जीवनात काही बिघाड आहे का?",
        talkAstrology: "किंवा या व्यतिरिक्त आपणास काही अन्य समस्या येत आहेत. म्हणून आपल्याशी ज्योतिषाशी बोला आणि आपल्या समस्या दूर करा.",
        comingsoon: "आम्ही आपल्या ज्योतिषशास्त्राद्वारे आपल्या समस्यांवर मात करण्यासाठी लवकरच येत आहोत.",
        terms: "मी सर्व <b> नियम व अटी </ b> वाचल्या आहेत आणि मी त्यास सहमती देतो. "


    },
    pa: {
        gems: "ਜੇਮਜ਼",
        solveProblems: "ਗੱਲ ਕਰੋ, ਆਪਣੀਆਂ ਸਮੱਸਿਆਵਾਂ ਦਾ ਹੱਲ ਕਰੋ",
        Makefriends: "ਦੋਸਤ ਬਣਾਓ",
        talkAboutRomantic: "ਨਵੇਂ ਦੋਸਤ ਬਣਾਓ ਅਤੇ ਆਪਣੇ ਦਿਲ ਦੀ ਸਥਿਤੀ ਬਾਰੇ ਜਾਣੋ",
        Astrology: "ਜੋਤਿਸ਼",
        problems: "ਤੁਹਾਡੀਆਂ ਸਮੱਸਿਆਵਾਂ ਅਤੇ ਤੁਹਾਡੇ ਘਰ ਤੋਂ ਦੂਰ",
        Baatein91: "ਬਾਤੇਨ .91",
        Callhistory: "ਕਾਲ ਦਾ ਇਤਿਹਾਸ",
        Nosufficientbal: "ਤੁਹਾਡੇ ਕੋਲ ਲੋੜੀਂਦਾ ਸੰਤੁਲਨ ਨਹੀਂ ਹੈ",
        Findfriends: "ਦੋਸਤ ਲੱਭੋ",
        Calling: "ਕਾਲ ਕਰ ਰਿਹਾ ਹੈ ...",
        Connecting: "ਕਨੈਕਟ ਕਰ ਰਿਹਾ ਹੈ ...",
        Mute: "ਚੁੱਪ",
        Speaker: "ਸਪੀਕਰ",
        Lookingfriends: "ਤੁਹਾਡੇ ਲਈ ਨਵੇਂ ਦੋਸਤ ਲੱਭ ਰਹੇ ਹੋ ...",
        callWaiting: "ਤੁਹਾਡੀ ਕਾਲ ਦਾ ਇੰਤਜ਼ਾਰ ਜਾਰੀ ਹੈ.",
        wanttotalk: "ਕੀ ਤੁਸੀਂ ਕਿਸੇ ਹੋਰ ਨਾਲ ਗੱਲ ਕਰਨਾ ਚਾਹੁੰਦੇ ਹੋ?",
        clickButton: "ਫਿਰ ਹੇਠ ਦਿੱਤੇ ਬਟਨ ਤੇ ਕਲਿਕ ਕਰੋ. ਨਹੀਂ ਤਾਂ ਇੰਤਜ਼ਾਰ ਕਰੋ, ਤੁਸੀਂ ਕਤਾਰ ਵਿੱਚ ਹੋ ਅਤੇ ਤੁਹਾਡੀ ਕਤਾਰ ਨੰਬਰ {userPositiontxt} ਹੈ.",
        FindAnotherFriend: "ਇਕ ਹੋਰ ਦੋਸਤ ਲੱਭੋ",
        walletbal: "ਤੁਹਾਡੇ ਕੋਲ ਤੁਹਾਡੇ ਬਟੂਏ ਵਿਚ<b> {userbal} ਜੇਮਜ਼ </ b>.",
        Muteoff: "ਚੁੱਪ ਬੰਦ",
        Muteon: "ਚੁੱਪ ਕਰੋ",
        TermsandConditions: "ਨਿਬੰਧਨ ਅਤੇ ਸ਼ਰਤਾਂ",
        callRate: "1. ਘੱਟੋ ਘੱਟ ਕਾਲ ਟਾਕ ਰੇਟ <b> 10 ਜੇਮਜ਼ / ਮਿੰਟ </ b> ਹੈ",
        callTime: "2. ਤੁਸੀਂ ਇਕ ਵਾਰ ਵਿਚ ਸਿਰਫ ਇਕ ਕਾਲ 'ਤੇ <b> 4 ਮਿੰਟ </ b> ਤਕ ਗੱਲ ਕਰ ਸਕਦੇ ਹੋ.",
        minAmount: "3. ਤੁਹਾਡੇ ਬਟੂਏ ਵਿਚ ਘੱਟੋ ਘੱਟ <b> 10 ਜੇਮਜ਼ </ b> ਹੋਣੇ ਚਾਹੀਦੇ ਹਨ",
        Caution: "ਸਾਵਧਾਨ",
        nodirtyTalk: "ਜੇ ਤੁਸੀਂ ਕਾਲ ਦੇ ਦੌਰਾਨ ਅਸ਼ੁੱਧ ਜਾਂ ਕੋਈ ਗੰਦੀ ਗੱਲ ਕਰਦੇ ਹੋ, ਤਾਂ ਤੁਹਾਡਾ ਖਾਤਾ ਤੁਰੰਤ ਬੰਦ ਹੋ ਜਾਵੇਗਾ.",
        wallet: "ਬਟੂਆ",
        job: "1. ਆਪਣੀ ਨੌਕਰੀ ਦੀ ਭਾਲ ਨਾ ਕਰੋ?",
        married: "2. ਕੀ ਤੁਸੀਂ ਵਿਆਹ ਨਹੀਂ ਕਰਵਾ ਰਹੇ?",
        children: "3. ਕੀ ਤੁਹਾਡੇ ਬੱਚੇ ਨਹੀਂ ਹਨ?",
        marriedLife: "4. ਕੀ ਤੁਹਾਡੇ ਵਿਆਹ ਵਿਚ ਕੋਈ ਰੁਕਾਵਟ ਆਈ ਹੈ?",
        talkAstrology: "ਜਾਂ ਕੀ ਤੁਸੀਂ ਇਨ੍ਹਾਂ ਤੋਂ ਇਲਾਵਾ ਕਿਸੇ ਹੋਰ ਸਮੱਸਿਆ ਦਾ ਸਾਹਮਣਾ ਕਰ ਰਹੇ ਹੋ. ਇਸ ਲਈ ਸਾਡੇ ਨਾਲ ਜੋਤਿਸ਼ ਨਾਲ ਗੱਲ ਕਰੋ ਅਤੇ ਆਪਣੀਆਂ ਸਮੱਸਿਆਵਾਂ ਨੂੰ ਦੂਰ ਕਰੋ.",
        comingsoon: "ਅਸੀਂ ਜਲਦੀ ਹੀ ਤੁਹਾਡੇ ਜੋਤਿਸ਼ ਨਾਲ ਤੁਹਾਡੀਆਂ ਮੁਸ਼ਕਲਾਂ ਨੂੰ ਦੂਰ ਕਰਨ ਲਈ ਆ ਰਹੇ ਹਾਂ.",
        terms: "ਮੈਂ ਸਾਰੇ <b> ਨਿਯਮ ਅਤੇ ਸ਼ਰਤਾਂ </ b> ਨੂੰ ਪੜ੍ਹ ਲਿਆ ਹੈ ਅਤੇ ਮੈਂ ਇਸ ਨਾਲ ਸਹਿਮਤ ਹਾਂ. "


    },
    te: {
        gems: "జేమ్స్",
        solveProblems: "మాట్లాడండి, మీ సమస్యలను పరిష్కరించండి",
        Makefriends: "స్నేహితులు చేసుకునేందుకు",
        talkAboutRomantic: "ఇప్పుడు శృంగార విషయాల గురించి మాట్లాడండి మరియు మీ హృదయాన్ని తెలుసుకోండి",
        Astrology: "ఆస్ట్రాలజీ",
        problems: "మీ సమస్యలకు మరియు మీ ఇంటికి దూరంగా ఉండండి",
        Baatein91: "విషయాలు91",
        Callhistory: "కాల్ చరిత్ర",
        Nosufficientbal: "మీకు తగినంత బ్యాలెన్స్ లేదు",
        Findfriends: "స్నేహితులను కనుగొనండి",
        Calling: "కాలింగ్ ...",
        Connecting: "కనెక్ట్ అవుతోంది ...",
        Mute: "మ్యూట్",
        Speaker: "స్పీకర్",
        Lookingfriends: "మీ కోసం క్రొత్త స్నేహితులను చూస్తున్నారా…",
        callWaiting: "మీ కాల్ వెయిటింగ్ జరుగుతోంది.",
        wanttotalk: "మీరు వేరొకరితో మాట్లాడాలనుకుంటున్నారా?",
        clickButton: "అప్పుడు క్రింది బటన్ పై క్లిక్ చేయండి. లేకపోతే వేచి ఉండండి, మీరు క్యూలో ఉన్నారు మరియు మీ క్యూ సంఖ్య {userPositiontxt}",
        FindAnotherFriend: "మరొక స్నేహితుడిని కనుగొనండి",
        walletbal: "మీకు  మీ వాలెట్‌లో <b> {userbal} జేమ్స్ </ b>",
        Muteoff: "మ్యూట్ ఆఫ్",
        Muteon: "మ్యూట్ చేయండి",
        TermsandConditions: "నిబంధనలు మరియు షరతులు",
        callRate: "1. కనీస కాల్ టాక్ రేట్ <b> 10 జేమ్స్ / నిమి </ b>",
        callTime: "2. మీరు ఒకేసారి కాల్‌లో <b> 4 నిమిషాలు </ b> వరకు మాత్రమే మాట్లాడగలరు.",
        minAmount: "3. మీ వాలెట్‌లో కనీసం <b> 10 జేమ్స్ </b> ఉండాలి",
        Caution: "హెచ్చరిక",
        nodirtyTalk: "మీరు కాల్ సమయంలో అసభ్యంగా లేదా ఏదైనా మురికిగా మాట్లాడితే, మీ ఖాతా వెంటనే మూసివేయబడుతుంది.",
        wallet: "Wallet",
        job: "1. మీ ఉద్యోగం కోసం వెతకడం లేదా?",
        married: "2. మీరు వివాహం చేసుకోలేదా?",
        children: "3. మీకు పిల్లలు లేరా?",
        marriedLife: "4. మీ వివాహంలో విచ్ఛిన్నం జరిగిందా?",
        talkAstrology: "లేదా మీరు వీటితో పాటు వేరే సమస్యను ఎదుర్కొంటున్నారా? కాబట్టి మాతో జ్యోతిషశాస్త్రం మాట్లాడండి మరియు మీ సమస్యలను తొలగించండి.",
        comingsoon: "మా జ్యోతిషశాస్త్రంతో మీ సమస్యలను అధిగమించడానికి మేము త్వరలో వస్తున్నాము.",
        terms: "నేను అన్ని <b> నిబంధనలు </ b> చదివాను మరియు నేను అంగీకరిస్తున్నాను. "


    },
    ta: {
        gems: "ஜேம்ஸ்",
        solveProblems: "பேசுங்கள், உங்கள் பிரச்சினைகளை தீர்க்கவும்",
        Makefriends: "நண்பர்களாக்கு",
        talkAboutRomantic: "புதிய நண்பர்களை உருவாக்கி, உங்கள் இதய நிலையை அறிந்து கொள்ளுங்கள்",
        Astrology: "ஜோதிடம்",
        problems: "உங்கள் பிரச்சினைகள் மற்றும் உங்கள் வீட்டிற்கு விலகி",
        Baatein91: "விஷயங்கள்",
        Callhistory: "அழைப்பு வரலாறு",
        Nosufficientbal: "உங்களிடம் போதுமான இருப்பு இல்லை",
        Findfriends: "நண்பர்களைக் கண்டுபிடி",
        Calling: "அழைக்கிறது ...",
        Connecting: "இணைக்கிறது ...",
        Mute: "முடக்கு",
        Speaker: "சபாநாயகர்",
        Lookingfriends: "உங்களுக்காக புதிய நண்பர்களைத் தேடுகிறீர்கள்…",
        callWaiting: "உங்கள் அழைப்பு காத்திருப்பு நடக்கிறது.",
        wanttotalk: "நீங்கள் வேறு ஒருவருடன் பேச விரும்புகிறீர்களா?",
        clickButton: "பின்னர் கீழே உள்ள பொத்தானைக் கிளிக் செய்க. இல்லையெனில் காத்திருங்கள், நீங்கள் வரிசையில் இருக்கிறீர்கள், உங்கள் வரிசை எண் {userPositiontxt} ஆகும்.",
        FindAnotherFriend: "மற்ற நண்பர் காணவும்",
        walletbal: "உங்களிடம்  உங்கள் பணப்பையில் <b> {userbal} ஜேம்ஸ் </ b>",
        Muteoff: "முடக்கு",
        Muteon: "முடக்கு",
        TermsandConditions: "விதிமுறைகள் மற்றும் நிபந்தனைகள்",
        callRate: "1. குறைந்தபட்ச அழைப்பு பேச்சு வீதம் <b> 10 ஜேம்ஸ் / நிமிடம் </ b>",
        callTime: "2. நீங்கள் ஒரு நேரத்தில் ஒரு அழைப்பில் <b> 4 நிமிடங்கள் </ b> வரை மட்டுமே பேச முடியும்.",
        minAmount: "3. உங்கள் பணப்பையில் குறைந்தபட்சம் <b> 10 ஜேம்ஸ் </b> இருக்க வேண்டும்",
        Caution: "எச்சரிக்கை",
        nodirtyTalk: "அழைப்பின் போது நீங்கள் அநாகரீகமாக அல்லது ஏதேனும் மோசமான பேச்சு செய்தால், உங்கள் கணக்கு உடனடியாக மூடப்படும்.",
        wallet: "கைப்பை",
        job: "1. உங்கள் வேலையைத் தேடவில்லையா?",
        married: "2. நீங்கள் திருமணம் செய்து கொள்ளவில்லையா?",
        children: "3. உங்களுக்கு குழந்தைகள் இல்லையா?",
        marriedLife: "4. உங்கள் திருமணத்தில் முறிவு ஏற்பட்டதா?",
        talkAstrology: "அல்லது இவை தவிர வேறு ஏதேனும் சிக்கலை எதிர்கொள்கிறீர்களா? எனவே எங்களுடன் ஜோதிடம் பேசுங்கள், உங்கள் பிரச்சினைகளை நீக்குங்கள்.",
        comingsoon: "எங்கள் ஜோதிடத்துடன் உங்கள் பிரச்சினைகளை சமாளிக்க நாங்கள் விரைவில் வருகிறோம்.",
        terms: "நான் எல்லா <b> விதிமுறைகள் மற்றும் நிபந்தனைகள் </b> படித்திருக்கிறேன், நான் அதை ஏற்றுக்கொள்கிறேன். "


    }
};

const i18n = new VueI18n({
    locale: "hi", // set locale
    fallbackLocale: "hi", // set fallback locale
    messages // set locale messages
});

export default i18n;